import cn from "classnames";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { FETCH_TIME_IN_MILLISECOND } from "constant";
import { FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ChangeFormationMode, ClearPaginationData } from "toolkit/steps/stepSix/stepSix.slice";
import {
	dowloadDocumentArchive,
	formDocumentPackage,
	getBatches,
	getDocumentArchive,
} from "toolkit/steps/stepSix/stepSix.thunks";
import styles from "./FormationDocument.module.sass";

interface FormationDocumentProps {
	close: () => void;
}

export const FormationDocument: FC<FormationDocumentProps> = ({ close }) => {
	const {
		currentBatch,
		attachmentList,
		archiveData,
		batchesMode,
		formationMode,
		newBatch,
		allCheckedGlobal,
		excludedObjects,
	} = useAppSelector((state) => state.stepSix);
	const dispatch = useAppDispatch();
	const { organizationId } = useParams();
	const [pending, setPending] = useState<boolean>(false);
	const [archiveDonwloaded, setArchiveDonwloaded] = useState<boolean>(false);

	const formationHandler = () => {
		setPending(true);
		if (formationMode && organizationId) {
			dispatch(
				formDocumentPackage({
					organizationId: +organizationId,
					allCheckedGlobal: Boolean(allCheckedGlobal),
					attachmentList,
					excludedObjects,
				}),
			);
		}
		if (batchesMode && organizationId && currentBatch?.id) {
			dispatch(getDocumentArchive({ organizationId: +organizationId, batchId: currentBatch?.id }));
		}
	};

	useEffect(() => {
		return () => {
			if (archiveDonwloaded && organizationId) {
				// разве getBatches нужен здесь? Он же в StepSix.tsx есть. 1042
				dispatch(getBatches(+organizationId));
				dispatch(ChangeFormationMode(false));
				dispatch(ClearPaginationData({ clearBatches: false }));
			}
		};
		//eslint-disable-next-line
	}, [archiveDonwloaded, organizationId]);

	const intefvalRef: any = useRef();
	useEffect(() => {
		if (!organizationId) return;
		if (batchesMode) {
			if (currentBatch?.id && !archiveData.formation && archiveData.URL) downloadDocument(currentBatch?.name);
			if (currentBatch?.id && archiveData.formation && !archiveData.URL)
				formDocument(+organizationId, currentBatch?.id);
		}

		if (formationMode) {
			if (newBatch?.id && !archiveData.formation && archiveData.URL) {
				downloadDocument(newBatch?.name);
				setArchiveDonwloaded(true);
			}
			if (newBatch?.id && archiveData.formation && !archiveData.URL) formDocument(+organizationId, newBatch?.id);
		}

		return () => {
			clearInterval(intefvalRef.current);
		};
		//eslint-disable-next-line
	}, [archiveData, newBatch?.id, archiveData.URL, archiveData.formation]);

	const formDocument = (organizationId: number, batchId: number) => {
		intefvalRef.current = setInterval(() => {
			dispatch(getDocumentArchive({ organizationId, batchId }));
		}, FETCH_TIME_IN_MILLISECOND);
	};

	const downloadDocument = (fileName: string) => {
		clearInterval(intefvalRef.current);
		dispatch(dowloadDocumentArchive({ name: fileName, archiveURL: archiveData.URL }));
		setPending(false);
	};

	const closeHandler = () => {
		close();
	};

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Сформировать пакет документов</h4>
			<span className={styles.subtitle}>
				{batchesMode && "Пакет документов по данной партии уже был сформирован. Сформировать ещё раз?"}
				{formationMode &&
					"Пакет документов будет сформирован по выбранным объектам. Процесс может занять несколько минут"}
			</span>
			{archiveDonwloaded ? (
				<Button onClick={closeHandler} type="button" full={true}>
					Готово
				</Button>
			) : (
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отменить
					</Button>
					<Button onClick={formationHandler} className={cn(styles.button, styles.pending)} loading={pending}>
						Сформировать
					</Button>
				</div>
			)}
		</section>
	);
};
